import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { updateAccountDataOfContact } from '../../Utility/UpdateAccountData/UpdateAccountData';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { setAllDataOfContact } from '../../Redux/Index';
import { useDispatch } from 'react-redux';

// Redux func start

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

// Redux func end

function AccountDetail({ allDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const originalId = id.substring(9, id.length - 4);

  const [isDataSubmitting, setIsDataSubmitting] = useState(false);
  const [accNameError, setAccNameError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [accountData, setAccountData] = useState({
    Id: originalId
  });

  useEffect(() => {

    if((allDataOfContact) && (allDataOfContact.success)) {
      setIsLoading(false);
    }

    if(Object.keys(accountData).length === 1) {
      if(allDataOfContact.data && allDataOfContact.data.Accounts) {
        allDataOfContact.data.Accounts.records.forEach((rowData) => {
          if(rowData.Id == originalId) {
            setAccountData({
                ...rowData,
                Street: rowData.ShippingAddress.street,
                City: rowData.ShippingAddress.city,
                State: rowData.ShippingAddress.state,
                Country: rowData.ShippingAddress.country,
                PostalCode: rowData.ShippingAddress.postalCode
            });
            return;
          }
        });
      }
  
    } 
    
  }, [allDataOfContact, isLoading, accountData]);


  // Input field value handler start

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setAccountData({
      ...accountData,
      [name]: value,
    });
  };

  // Input field value handler end

  // Input field error handler start

  const accountNameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && value=="") {
        setAccNameError(true);
    } else {
        setAccNameError(false);
    }
  }

  // Input field error handler end

  // Contact submit func start

  function submitAccountData() {
    loginTimeOutAndRedirectHandler(updateAccountDataOfContact, accountData, dispatch, setAllDataOfContact, navigate, "/", "Account detail updated!", setIsDataSubmitting, "/Accounts");
  }

  // Contact submit func start

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginLeft: 2, marginBottom: 2, fontWeight: 'bold' }}
            >
              My Accounts
            </Typography>
        <CssBaseline />
        { Object.keys(accountData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
          <InputLabel htmlFor="accountname" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Account Name</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="accountname"
              type="text"
              required
              error={accNameError}
              name="Name"
              placeholder="Enter Account Name"
              helperText={accNameError ? 'Account name is required!' : ''} 
              value={accountData.Name == null ? "" : accountData.Name}
              onChange={(e) => { accountNameFieldErrorHandler(e);handleInputChange(e); }}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="phone" style={{ textAlign: "left" }}>Phone</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="phone"
              name="Phone"
              value={accountData.Phone == null ? "" : accountData.Phone}
              placeholder="Enter Phone"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="type" style={{ textAlign: "left", marginBottom: "1rem" }}>Type</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="type"
                value={(accountData.Type == "--None--" || accountData.Type == null) ? "--None--" : accountData.Type}
                name="Type"
                placeholder="Select Type"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Prospect"}>Prospect</MenuItem>
                <MenuItem value={"Customer - Direct"}>Customer - Direct</MenuItem>
                <MenuItem value={"Customer - Channel"}>Customer - Channel</MenuItem>
                <MenuItem value={"Channel Partner/Reseller"}>Channel Partner/Reseller</MenuItem>
                <MenuItem value={"Installation Partner"}>Installation Partner</MenuItem>
                <MenuItem value={"Technology Partner"}>Technology Partner</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="industry" style={{ textAlign: "left", marginBottom: "1rem" }}>Industry</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="industry"
                value={(accountData.Industry == "--None--" || accountData.Industry == null) ? "--None--" : accountData.Industry}
                name="Type"
                placeholder="Select Industry"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Agriculture"}>Agriculture</MenuItem>
                <MenuItem value={"Apparel"}>Apparel</MenuItem>
                <MenuItem value={"Banking"}>Banking</MenuItem>
                <MenuItem value={"Biotechnology"}>Biotechnology</MenuItem>
                <MenuItem value={"Chemicals"}>Chemicals</MenuItem>
                <MenuItem value={"Communications"}>Communications</MenuItem>
                <MenuItem value={"Construction"}>Construction</MenuItem>
                <MenuItem value={"Consulting"}>Consulting</MenuItem>
                <MenuItem value={"Education"}>Education</MenuItem>
                <MenuItem value={"Electronics"}>Electronics</MenuItem>
                <MenuItem value={"Energy"}>Energy</MenuItem>
                <MenuItem value={"Engineering"}>Engineering</MenuItem>
                <MenuItem value={"Entertainment"}>Entertainment</MenuItem>
                <MenuItem value={"Environmental"}>Environmental</MenuItem>
                <MenuItem value={"Finance"}>Finance</MenuItem>
                <MenuItem value={"Food & Beverage"}>Food & Beverage</MenuItem>
                <MenuItem value={"Government"}>Government</MenuItem>
                <MenuItem value={"Healthcare"}>Healthcare</MenuItem>
                <MenuItem value={"Hospitality"}>Hospitality</MenuItem>
                <MenuItem value={"Insurance"}>Insurance</MenuItem>
                <MenuItem value={"Machinery"}>Machinery</MenuItem>
                <MenuItem value={"Manufacturing"}>Manufacturing</MenuItem>
                <MenuItem value={"Media"}>Media</MenuItem>
                <MenuItem value={"Not For Profit"}>Not For Profit</MenuItem>
                <MenuItem value={"Recreation"}>Recreation</MenuItem>
                <MenuItem value={"Retail"}>Retail</MenuItem>
                <MenuItem value={"Shipping"}>Shipping</MenuItem>
                <MenuItem value={"Technology"}>Technology</MenuItem>
                <MenuItem value={"Telecommunications"}>Telecommunications</MenuItem>
                <MenuItem value={"Transportation"}>Transportation</MenuItem>
                <MenuItem value={"Utilities"}>Utilities</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="annualrevenue" style={{ textAlign: "left" }}>Annual Revenue</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="annualrevenue"
              name="AnnualRevenue"
              value={accountData.AnnualRevenue == null ? "" : accountData.AnnualRevenue}
              placeholder="Enter Annual Revenue"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="active" style={{ textAlign: "left", marginBottom: "1rem" }}>Active</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="active"
                value={(accountData.Active__c == "--None--" || accountData.Active__c == null) ? "--None--" : accountData.Active__c}
                name="Active__c"
                placeholder="Select Active"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Yes"}>Yes</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="street" style={{ textAlign: "left" }}>Street</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="street"
              name="Street"
              value={accountData.Street == null ? "" : accountData.Street}
              placeholder="Enter Street"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="city" style={{ textAlign: "left" }}>City</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="city"
              name="City"
              value={accountData.City == null ? "" : accountData.City}
              placeholder="Enter City"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="state" style={{ textAlign: "left" }}>State</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="state"
              name="State"
              value={accountData.State == null ? "" : accountData.State}
              placeholder="Enter State"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="country" style={{ textAlign: "left" }}>Country</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="country"
              name="Country"
              value={accountData.Country == null ? "" : accountData.Country}
              placeholder="Enter Country"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="postalCode" style={{ textAlign: "left" }}>Postal Code</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="postalCode"
              name="PostalCode"
              value={accountData.PostalCode == null ? "" : accountData.PostalCode}
              placeholder="Enter Postal Code"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={2} md={6} lg={8}>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => { setIsDataSubmitting(true);submitAccountData() }}
              disabled={ accountData.Name == "" ? true : false }
            >
              { isDataSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Update" }
            </Button>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Link to="/Accounts" style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="submit"
              fullWidth
              variant="outlined"
              sx={{ mt: 3, mb: 2 }}
            >
              Cancel
            </Button>
            </Link>
            </Grid>
          </Grid>
        </Box> }
        


          </Container>
  )
}

export default connect(mapStateToPropsForAllData)(AccountDetail);